import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-media-recorder',
  templateUrl: './media-recorder.component.html',
  styleUrls: ['./media-recorder.component.scss']
})
export class MediaRecorderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
